import React from 'react';
import cx from 'classnames';

import Tooltip from '~/components/tooltip/tooltip';
import { useSanityProduct } from '~/features/products/products-actions';
import { TriggerModalWrapper } from '~/components/sunday-store/components/product-card';
import PlanFaqTrigger from '~/components/plans/bundles-page/plan-faq-trigger';
import {
  WeedWarriorCard,
  WeedWarriorCta,
} from '~/components/shipments/weed-warrior-components';

import styles from '~/components/shipments/shipment.module.scss';

function ShipmentItemsList({
  shipmentItems = [],
  size,
  showProductDetailsModal,
  faqContent,
  showAltTooltip,
  showWeedProduct,
}) {
  return (
    <div
      className={cx(styles.shipmentItems, {
        [styles.shipmentItemsSmall]: size === 'small',
        [styles.shipmentItemsLarge]: size === 'large',
        [styles.faqGrid]: Boolean(faqContent),
      })}
    >
      {showWeedProduct && (
        <div className={styles.productWrapperDesktop}>
          <WeedWarriorCta />
          <WeedWarriorCard />
        </div>
      )}

      {shipmentItems.map((shipmentItem, idx) => (
        <ShipmentItem
          shipmentItem={shipmentItem}
          key={`${shipmentItem.skuId}:${idx}`}
          showProductDetailsModal={showProductDetailsModal}
          showAltTooltip={showAltTooltip}
        />
      ))}
      {faqContent && <PlanFaqTrigger faqContent={faqContent} />}
    </div>
  );
}

function ShipmentItem({
  shipmentItem,
  showProductDetailsModal,
  showAltTooltip,
}) {
  const shipmentSkuId = shipmentItem?.shipmentSkuSkuId;

  const { product } = useSanityProduct(shipmentSkuId, {
    enabled: showProductDetailsModal,
  });

  const name = shipmentItem?.name || shipmentItem?.title;

  const showTooltip =
    (showAltTooltip && product?.tooltipVariantCopy) || shipmentItem?.detail;

  const tooltipCopy =
    showAltTooltip && product?.tooltipVariantCopy
      ? product.tooltipVariantCopy
      : shipmentItem.detail;

  if (showProductDetailsModal && product) {
    return (
      <TriggerModalWrapper
        product={{ productDetails: product, purchaseSku: {} }}
        ctaButton={' '}
        showViewDetailsButton={false}
        showAtc={false}
        showPspCopy
      >
        <div className={styles.shipmentItem}>
          <div className={styles.imageContainer}>
            <img
              src={shipmentItem.imageUrl}
              alt={name}
              width="300"
              height="300"
              className={styles.shipmentItemImage}
            />
            {shipmentItem.quantity > 1 && (
              <div className={styles.shipmentItemQuantity}>
                {shipmentItem.quantity}
              </div>
            )}
            <div className={styles.viewDetailsBadge}>
              <img src="/icons/eye-icon.svg" alt="Eye" />
              View details
            </div>
          </div>
          <div className={styles.shipmentItemTitle}>{name}</div>
        </div>
      </TriggerModalWrapper>
    );
  }

  return (
    <div className={styles.shipmentItem}>
      <div className={styles.imageContainer}>
        <img
          src={shipmentItem.imageUrl}
          alt={name}
          width="300"
          height="300"
          className={styles.shipmentItemImage}
        />
        {shipmentItem.quantity > 1 && (
          <div className={styles.shipmentItemQuantity}>
            {shipmentItem.quantity}
          </div>
        )}
      </div>
      <div className={styles.shipmentItemTitle}>
        {name}
        {showTooltip && (
          <span className={styles.shipmentItemTooltip}>
            <Tooltip
              content={tooltipCopy}
              eventData={{ sku_id: shipmentSkuId }}
            />
          </span>
        )}
      </div>
    </div>
  );
}

export default ShipmentItemsList;
